const tr = {
  nav: {
    about: 'Hakkımda',
    resume: 'Özgeçmiş',
    projects: 'Projeler',
    contact: 'İletişim',
  },
  projects: {
    title: 'Projeler',
    subtitle: 'Üzerinde çalıştığım projeler',
  },
  sidebar: {
    about: 'Hakkımda',
    description: 'Merhaba, ben Mustafa. Erciyes Üniversitesi Bilgisayar Mühendisliği mezunuyum. Yapı Kredi Teknoloji\'de Uzman Yazılım Mühendisi olarak Java Spring Boot ve React ile finans sektöründe fullstack uygulamalar geliştiriyorum.',
    learnMore: 'Daha Fazla',
    aboutMe: 'Hakkımda',
  },
  index: {
    greeting: 'Bana ulaşmak ister misin? E-posta gönderebilirsin:',
  },
  about: {
    title: 'Hakkımda',
    wordCount: '(yaklaşık {count} kelime)',
  },
  resume: {
    title: 'Özgeçmiş',
    education: 'Eğitim',
    experience: 'Deneyim',
    techStacks: 'Teknolojiler',
    awards: 'Ödüller',
    present: 'GÜNCEL',
    downloadCV: 'CV İndir',
    preparingCV: 'CV hazırlanıyor',
    downloadFailed: 'İndirme tamamlanamadı. Lütfen tekrar dene.',
  },
  contact: {
    title: 'İletişim',
    description: 'Bana ulaşmak ister misin? E-posta gönderebilirsin:',
    formTitle: 'Ya da bana mesaj bırak',
    name: 'Ad Soyad',
    email: 'E-posta',
    message: 'Mesaj',
    send: 'Mesajı Gönder',
    sending: 'Gönderiliyor...',
    sent: 'Teşekkürler! Mesajın gönderildi.',
    error: 'Mesajın gönderilemedi. Lütfen daha sonra tekrar dene.',
    verificationFailed: 'Doğrulama başarısız oldu. Lütfen tekrar dene.',
  },
  notFound: {
    title: 'Sayfa Bulunamadı',
    returnHome: 'Ana sayfaya',
    home: 'dön',
  },
  awards: {
    issuedBy: 'Kurum:',
  },
};

export default tr;
